import { createIcon } from "@chakra-ui/icons";

export const UploadIcon = createIcon({
  displayName: "UploadIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16.005 15.998-4-4m0 0-4 4m4-4v9m8.39-2.61a5 5 0 0 0-2.39-9.39h-1.26a8 8 0 1 0-13.74 7.3"
    />
  ),
});
